import * as React from 'react';
import DataGrid from '../components/DataGrid';
import GetColumnDefs from '../components/ColumnDefs';
import Notifications from '../components/Notifications';
import { GetPermissions } from '../components/Options';
import { useNavigate } from "react-router-dom";
import configData from "../config.json";
import { GetToken } from '../components/Session';
import { DropDownList } from "@progress/kendo-react-dropdowns";

const Dockets = () => {
    const [columns, setColumns] = React.useState(null);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [permissions, setPermissions] = React.useState(null);
    const [sites, setSites] = React.useState([]);
    const [site, setSite] = React.useState();
    const navigate = useNavigate();
    const [lookupParams, setLookupParams] = React.useState("");
    if (permissions && !permissions.CanView) navigate("/error401");
    const [layout, setLayout] = React.useState([
        { "field": "searchSite", "label": "Site", "isVisible": true, "type": "list" },
    ]);
    if (localStorage.getItem("userid") === null) navigate("/logout");

    React.useEffect(() => {
        GetColumnDefs("DocketTemplates", setColumns, setErrorMessage);
        GetPermissions(["ViewDocketTemplates", "NewDocketTemplates", "EditDocketTemplates", "DeleteDocketTemplates"], setPermissions);
        let baseUrl = configData.SERVER_URL + "apiv7/options";
        const init = {
            method: "GET",
            accept: "application/json",
            headers: { "Authorization": "Bearer " + GetToken() },
        };
        baseUrl = configData.SERVER_URL + "apiv7/options";
        fetch(baseUrl, init).then((response) => response.json()).then((d) => {

            setSites(CreateList(d.sites));
            let s = localStorage.getItem("docketsite");
            if (s === null || s === "") s = "0";
            let st = d.sites.find(obj => obj.id === s);
            if (st === undefined) {
                setSite({ id: "0", name: "All" });
            }
            else {
                setSite(st);
                setLookupParams(s);
            }
        });
    }, []);

    const GetField = (f) => {
        return layout.find(obj => { return obj.field === f });
    }
    const siteChanged = (event) => {
        setSite(event.target.value);
        localStorage.setItem("docketsite", event.target.value.id);
        if (event.target.value.id == "0")
            setLookupParams("");
        else
            setLookupParams(event.target.value.id);
    }
    const CreateList = (d) => {
        var x = [{ id: "0", name: "All" }, {id: "1", name: "Cloud (1)"}];
        d.map((v) => x.push({ id: v.id, name: v.name + " (" + v.id + ")" }));
        return x;
    };


    return ( 
        <div>
            <Notifications errorMessage={errorMessage} />
            <div className="row" style={{ padding: "5px 10px" }}>
                {GetField("searchSite")["isVisible"] && <div className="col-md-3">
                    <label className="control-label">{GetField("searchSite")["label"]}</label>
                    <DropDownList id="Site" data={sites} value={site} textField="name" dataItemKey="id" onChange={siteChanged} />
                </div>}
            </div>
            {columns && permissions && <DataGrid dataSource='apiv7/dockettemplates' columns={columns} permissions={permissions} params={lookupParams} keyField ="docketTemplateId" />}
        </div>       
    );
}

export default Dockets;